/**
 * Centralized story categories - single source of truth
 * Used across CreatePage, SearchPage, StoryViewer, and other components
 */

import {
  Mountain, PawPrint, Moon, Users, Home, Laugh,
  Leaf, Sparkles, BookOpen, GraduationCap, BookMarked
} from 'lucide-react';

// Common children's book categories - matching real-world bookstore sections
export const STORY_CATEGORIES = [
  { value: "adventure", label: "Adventure", icon: Mountain },
  { value: "animals", label: "Animals", icon: PawPrint },
  { value: "bedtime", label: "Bedtime", icon: Moon },
  { value: "fairy-tales", label: "Fairy Tales", icon: Sparkles },
  { value: "family", label: "Family", icon: Home },
  { value: "fantasy", label: "Fantasy", icon: BookOpen },
  { value: "friendship", label: "Friendship", icon: Users },
  { value: "funny", label: "Funny", icon: Laugh },
  { value: "learning", label: "Learning", icon: GraduationCap },
  { value: "nature", label: "Nature", icon: Leaf },
  { value: "biblical", label: "Biblical", icon: BookMarked },
];

// Get just the labels as an array (for simple dropdowns)
export const CATEGORY_LABELS = STORY_CATEGORIES.map(cat => cat.label);

// Get just the values as an array
export const CATEGORY_VALUES = STORY_CATEGORIES.map(cat => cat.value);

// Helper to get label from value
export const getCategoryLabel = (value) => {
  const category = STORY_CATEGORIES.find(cat => cat.value === value);
  return category?.label || value;
};

// Helper to get value from label
export const getCategoryValue = (label) => {
  const category = STORY_CATEGORIES.find(cat => cat.label === label);
  return category?.value || label.toLowerCase();
};
